<template>
  <div class="outages-list-utility">
    <div
    class="list-container">
      <vue-scroll :ops="vueScrollOptions">
          <div class="list-container-inner">
            <vue-good-table
            styleClass="vtoutages-vgt-table"
            v-if="tableRows && tableRows.length"
            :rows="tableRows"
            :columns="tableColumns"
            :sort-options="{
              enabled: true,
              initialSortBy: [
                {field: 'totalCustomers', type: 'desc'},
                {field: 'name', type: 'asc'}
              ],
            }">
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'name'">
                <span v-bind:class="{strong: props.row.totalEvents > 0}">{{props.row.name}}</span>
                <span
                class="url"
                v-if="props.row.url"
                :title="'View the ' + props.row.name + ' web site'">
                  <a :href="props.row.url" target="_blank">
                    <img src="../../../assets/img/new-window-link-icon.png" alt="new-window-link-icon">
                  </a>
                </span>
              </span>
              <span v-else-if="props.column.field == 'asOfDate'">
                  <span v-bind:class="{strong: props.row.totalEvents > 0}">{{props.row.asOfDate | asOfDateAgo}}</span>
              </span>
              <span v-else>
                <span v-bind:class="{strong: props.row.totalEvents > 0}">{{props.formattedRow[props.column.field]}}</span>
              </span>
            </template>
          </vue-good-table>
          </div>
      </vue-scroll>
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
import OutagesListMixin from "@/components/shared/mixins/OutagesListMixin";

export default {
  name: 'OutagesListUtility',
  mixins: [OutagesListMixin],
  props: {
    utilityOutages: Array
  },
  components: {
    VueGoodTable,
  },
  watch: {
    utilityOutages: function () {this.tableRows = this.utilityOutages}
  },
  created() {
    this.initVueScrollHelpers();
  },
  beforeDestroy() {
    this.destroyScrollHelpers();
  },
  data(){
    return {
      tableColumns: [
        {
          label: 'Name',
          field: 'name',
          width: '100px'
        },
        {
          label: 'Customers',
          field: 'totalCustomers',
          type: 'number',
          width: '90px'
        },
        {
          label: 'Events',
          field: 'totalEvents',
          type: 'number',
          width: '70px'
        },
        {
          label: 'As Of',
          field: 'asOfDate',
          type: 'string',
          width: '70px'
        }
      ],
      tableRows: this.utilityOutages
    };
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/css/partials/_variables.scss";

.outages-list-utility{
  margin: 20px 0 0 0;
  padding: 0;
  text-align: left;

  .list-container{
    width: 90%;
    margin: 0 auto;
    font-size: 14px;

    ::v-deep .vgt-wrap{
      table {
        &.vtoutages-vgt-table{
          width: 100%;
          table-layout: fixed;
          border-collapse: collapse;
          border-spacing: 0;
          color: $whiteTextTrans85;
          font-weight: normal;

          thead {
            border-bottom: 1px solid $greyTextTrans65;

            tr {
              th {
                position: relative;
                padding-bottom: 10px;
                text-transform: uppercase;
                text-align: center;
                color: #fff;
                font-weight: 400;
                right: 5px;

                &:first-child{
                  padding-left: 30px;
                  text-align: left;
                }

                &.sortable{
                  &:before {
                    cursor: pointer;
                    content: "";
                    position: absolute;
                    height: 0;
                    width: 0;
                    right: 0;
                    top: 35%;
                    margin-bottom: -7px;
                    border-left: 5px solid transparent;
                    border-right: 5px solid transparent;
                    border-top: 5px solid #cfd3e0;
                  }

                  &:after {
                    cursor: pointer;
                    content: "";
                    position: absolute;
                    height: 0;
                    width: 0;
                    right: 0;
                    top: 35%;
                    margin-top: -7px;
                    border-left: 5px solid transparent;
                    border-right: 5px solid transparent;
                    border-bottom: 5px solid #cfd3e0;
                  }
                }
              }
            }
          }

          tbody {
            tr {
              border-bottom: 1px solid $greyTextTrans25;

              &:last-child{
                border: none;
              }

              td {
                height: 28px;
                text-align: center;
                line-height: 28px;

                &:first-child{
                  position: relative;
                  padding-left: 30px;
                  text-align: left;

                  .url{
                    position: absolute;
                    top: -2px;
                    right: -20px;
                  }
                }

                .strong{
                  font-weight: 700;
                  color: #fff;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
